import { TFunction } from 'i18next';

import { uiHelpers } from '../../../helpers';
import {
  ExternalSeriesGenerator,
  getDefaultToolptipFormatter,
  PriceViewerSeries,
} from './base';

interface AAII {
  date: string;
  mean: number;
  stdev: number;
  v: number;
  updateTime: number;
}

class AAII extends ExternalSeriesGenerator {
  isSeparateFromPriceChart = true;
  height = 200;

  data: AAII[];
  title: string;
  constructor(t: TFunction, data: AAII[], title: string) {
    super(t);
    this.data = data;
    this.title = title;
  }

  getChartName(): string {
    let updateTime;
    if (this.data.length > 0) {
      updateTime = [...this.data]
        .reverse()
        .find(data => data.updateTime)?.updateTime;
    }
    const sentiment =
      this.title === 'bearish'
        ? this.t('aaii-bearish')
        : this.t('aaii-bullish');
    if (updateTime) {
      return (
        sentiment +
        ' ' +
        this.t('Updated at') +
        ' ' +
        uiHelpers.formatDateTimeLocalFromTimestamp(updateTime)
      );
    }
    return sentiment;
  }

  getSeries(): PriceViewerSeries[] {
    const upperAAII2stdev = [],
      upperAAII1stdev = [],
      AAIIData = [],
      lowerAAII1stdev = [],
      lowerAAII2stdev = [];

    for (const item of this.data) {
      upperAAII2stdev.push([item.date, item.mean + 2 * item.stdev]);
      upperAAII1stdev.push([item.date, item.mean + 1 * item.stdev]);
      lowerAAII1stdev.push([item.date, item.mean - 1 * item.stdev]);
      lowerAAII2stdev.push([item.date, item.mean - 2 * item.stdev]);
      AAIIData.push([item.date, item['v']]);
    }
    const sentiment =
      this.title === 'bearish'
        ? this.t('aaii-bearish')
        : this.t('aaii-bullish');
    return [
      {
        name: sentiment + 'upper 2sd',
        echartSeries: {
          type: 'line',
          connectNulls: true,
          data: upperAAII2stdev,
          symbol: 'none',
          lineStyle: {
            opacity: 0.8,
            color: '#ca6702',
            type: 'dashed',
          },
        },
        tooltipFormatter: getDefaultToolptipFormatter('2d', 'number', {
          keyColor: '#ca6702',
        }),
      },
      {
        name: sentiment + 'upper 1sd',
        echartSeries: {
          type: 'line',
          connectNulls: true,
          data: upperAAII1stdev,
          symbol: 'none',
          lineStyle: {
            opacity: 0.8,
            color: '#48cae4',
            type: 'dashed',
          },
        },
        tooltipFormatter: getDefaultToolptipFormatter('2d', 'number', {
          keyColor: '#48cae4',
        }),
      },
      {
        name: sentiment,
        echartSeries: {
          type: 'line',
          connectNulls: true,
          data: AAIIData,
          symbol: 'none',
          lineStyle: {
            opacity: 0.8,
            color: this.title === 'bearish' ? '#FF0000' : '#0a9396',
          },
        },
        tooltipFormatter: getDefaultToolptipFormatter('2d', 'number', {
          keyColor: this.title === 'bearish' ? '#FF0000' : '#0a9396',
        }),
      },
      {
        name: sentiment + 'lower 1sd',
        echartSeries: {
          type: 'line',
          connectNulls: true,
          data: lowerAAII1stdev,
          symbol: 'none',
          lineStyle: {
            opacity: 0.8,
            color: '#48cae4',
            type: 'dashed',
          },
        },
        tooltipFormatter: getDefaultToolptipFormatter('2d', 'number', {
          keyColor: '#48cae4',
        }),
      },
      {
        name: sentiment + 'lower 2sd',
        echartSeries: {
          type: 'line',
          connectNulls: true,
          data: lowerAAII2stdev,
          symbol: 'none',
          lineStyle: {
            opacity: 0.8,
            color: '#ca6702',
            type: 'dashed',
          },
        },
        tooltipFormatter: getDefaultToolptipFormatter('2d', 'number', {
          keyColor: '#ca6702',
        }),
      },
    ];
  }
}

export default AAII;
